// 원문자 변환 (2026-09-27).
//
// 고른 글자를 ①Ⓐⓐ㉠㉮ 같은 **동그라미 문자**로 바꾼다. 서식이 아니라 글자 자체를
// 바꾸는 것이라 Quill 포맷이 아닌 텍스트 치환으로 처리한다.
//
// 🔴 예전 '원문자' 버튼은 `ql-strike` 에 라벨만 덮어쓴 것이라 실제로는 **취소선**이
//    들어갔다(DB 에 `<s>` 를 쓴 기사는 0건이었다). 2026-09-27 에 제 기능으로 만들었다.

const A = 'A'.charCodeAt(0), Z = 'Z'.charCodeAt(0)
const a = 'a'.charCodeAt(0), z = 'z'.charCodeAt(0)

// 한글 자음 14개와 '가~하' 14개는 유니코드에 연속으로 있다.
const JAMO = 'ㄱㄴㄷㄹㅁㅂㅅㅇㅈㅊㅋㅌㅍㅎ'
const GANADA = '가나다라마바사아자차카타파하'

function circleOne(ch) {
    const c = ch.charCodeAt(0)
    if (ch === '0') return '⓪'                       // ⓪
    if (ch >= '1' && ch <= '9') return String.fromCharCode(0x2460 + (c - 0x31))   // ①~⑨
    if (c >= A && c <= Z) return String.fromCharCode(0x24B6 + (c - A))            // Ⓐ~Ⓩ
    if (c >= a && c <= z) return String.fromCharCode(0x24D0 + (c - a))            // ⓐ~ⓩ
    const j = JAMO.indexOf(ch)
    if (j >= 0) return String.fromCharCode(0x3260 + j)                            // ㉠~㉭
    const g = GANADA.indexOf(ch)
    if (g >= 0) return String.fromCharCode(0x326E + g)                            // ㉮~㉻
    return ch
}

function unCircleOne(ch) {
    const c = ch.charCodeAt(0)
    if (c === 0x24EA) return '0'
    if (c >= 0x2460 && c <= 0x2468) return String.fromCharCode(0x31 + (c - 0x2460))
    if (c >= 0x24B6 && c <= 0x24CF) return String.fromCharCode(A + (c - 0x24B6))
    if (c >= 0x24D0 && c <= 0x24E9) return String.fromCharCode(a + (c - 0x24D0))
    if (c >= 0x3260 && c <= 0x326D) return JAMO[c - 0x3260]
    if (c >= 0x326E && c <= 0x327B) return GANADA[c - 0x326E]
    // ⑩~⑳ 은 두 자리라 되돌리면 글자 수가 늘어난다. 여기서만 예외로 문자열을 돌려준다.
    if (c >= 0x2469 && c <= 0x2473) return String(10 + (c - 0x2469))
    return ch
}

export function isCircled(text) {
    for (const ch of String(text || '')) {
        if (unCircleOne(ch) !== ch) return true
    }
    return false
}

export function toCircled(text) {
    let out = ''
    for (const ch of String(text || '')) out += circleOne(ch)
    return out
}

export function toPlain(text) {
    let out = ''
    for (const ch of String(text || '')) out += unCircleOne(ch)
    return out
}

// 🔴 **10 이상은 두 글자라 한 글자로 못 만든다.** '12' 를 ⑫ 로 바꾸려면 앞뒤를 묶어야
//    하는데, 그러면 '1'+'2' 를 ①② 로 원하는 경우와 구분할 수 없다. 한 글자씩만 바꾼다.
//    (되돌릴 때는 ⑩~⑳ 도 숫자로 풀어 준다 — 다른 곳에서 붙여 온 글자일 수 있다.)
export default { toCircled, toPlain, isCircled }
